import { queryOptions } from '@tanstack/react-query';

import { api } from '#client';
import { parseSchema } from '#client/validation';

import { IndustryResponse } from './industry.types';

const getNaicsCodes = (): Promise<IndustryResponse> =>
	api.get(`/claims/naicscodes`).then(parseSchema(IndustryResponse));

const getUkIndustryCodes = (): Promise<IndustryResponse> =>
	// use naics codes endpoint for uk industries as well, until we have a uk specific endpoint
	api.get(`/claims/naicscodes`).then(parseSchema(IndustryResponse));

export const industryQueries = {
	naics: () =>
		queryOptions({
			queryKey: ['naics'],
			queryFn: () => getNaicsCodes(),
		}),
	uk: () =>
		queryOptions({
			queryKey: ['ukIndustries'],
			queryFn: () => getUkIndustryCodes(),
		}),
};
